import React, { useState } from 'react';
import { IconChevron } from '../../assets/icons/IconChevron';
import { HistoryTableHeader } from './HistoryTableHeader';

interface HistoryGroupProps {
    groupKey: string;
    label: string;
    headingTestId: string;
    /** Lets the heading fold the table away, for the global history where months pile up. */
    collapsible: boolean;
    children: React.ReactNode;
}

export const HistoryGroup: React.FC<HistoryGroupProps> = ({ groupKey, label, headingTestId, collapsible, children }) => {
    const [open, setOpen] = useState(true);
    const headingId = `history-group-${groupKey}`;
    const tableId = `history-group-table-${groupKey}`;

    return (
        <section aria-labelledby={headingId} className="flex flex-col gap-s">
            <h2 id={headingId} className="text-body-emphasized text-content" data-testid={headingTestId}>
                {collapsible ? (
                    <button
                        type="button"
                        aria-expanded={open}
                        aria-controls={tableId}
                        onClick={() => setOpen(o => !o)}
                        data-testid={`${headingTestId}-toggle`}
                        className="flex items-center gap-xs rounded-sm cursor-pointer focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-focus-ring"
                    >
                        <IconChevron className={`size-3.5 shrink-0 text-icon-secondary transition-transform duration-150 ${open ? '-rotate-90' : 'rotate-90'}`} />
                        {label}
                    </button>
                ) : label}
            </h2>
            {open && (
                <div id={tableId} className="grid grid-cols-history md:grid-cols-history-wide gap-x-xl rounded-lg border border-line-card bg-surface-elevated shadow-weak overflow-hidden">
                    <HistoryTableHeader />
                    {children}
                </div>
            )}
        </section>
    );
};
